import { unininitializedState } from '../store'

import {
  BEGIN_INITIALIZATION,
  END_INITIALIZATION,
  ADD_FIRESTORE_UNLISTENER,
  COMPLETE_LIST_INFO_LOAD,
  COMPLETE_TODO_ITEM_LOAD,
  CLEAR_ALL
} from '../actions/actionTypes'

function firestore (state = {}, action) {
  switch (action.type) {
    case BEGIN_INITIALIZATION:
      return {
        ...state,
        isInitializing: true
      }

    case END_INITIALIZATION:
      return {
        ...state,
        isInitializing: false
      }

    case ADD_FIRESTORE_UNLISTENER:
      const updatedUnlisteners = [...state.unlisteners, action.unlistener]
      return {
        ...state,
        unlisteners: updatedUnlisteners
      }

    case COMPLETE_LIST_INFO_LOAD:
      return {
        ...state,
        listInfoIsLoaded: true
      }

    case COMPLETE_TODO_ITEM_LOAD:
      return {
        ...state,
        todoItemsAreLoaded: true
      }

    case CLEAR_ALL:
      return unininitializedState.firestore

    default:
      return state
  }
}

export default firestore



// WEBPACK FOOTER //
// ./src/reducers/firestore.js